module.exports = __webpack_public_path__ + "static/SH-13c05637ccd7e5d1174cf031e5c18de7.png";